import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { isUsePEP } from 'store/user/selectors';
import { getDealersInfo, pickerCheck } from 'data-providers/applicationsProvider';

import { APPLICATION_ROLES } from 'constants';

export const useMainAnketaPresenter = ({ data }) => {
  const isPEP = useSelector(isUsePEP);
  const role = useSelector((state) => state.user.role || -1);
  const { currentPersonId, isPEPSignature, application } = useSelector(
    (state) => state.anketa || {}
  );

  const [isPickUp, setIsPickUp] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isContentHidden, setIsContentHidden] = useState(false);
  const [isSpecialСonditions, setIsSpecialСonditions] = useState(false);

  const selfAgreement = useMemo(
    () => data?.persons[currentPersonId]?.selfAgreement || false,
    [data, currentPersonId]
  );

  const isShowDocuments = useMemo(() => !(selfAgreement || isPEP), [selfAgreement, isPEP]);

  const setFocusAt = useCallback((id, withClick = false) => {
    setTimeout(() => {
      const element = document.getElementById(id);

      if (element) {
        withClick ? element.click() : element.focus();
      }
    }, 50);
  }, []);

  const fetchSpecialConditions = useCallback(async () => {
    try {
      const dealerId = data?.application?.dealer?.id;

      if (!dealerId) {
        return;
      }

      const dealersInfo = await getDealersInfo([dealerId]);

      if (dealersInfo.data[0]?.specialDistribution) {
        setIsSpecialСonditions(true);

        const check = await pickerCheck(application.id);

        if (check) {
          setIsPickUp(check.data.running);
        }
      }
    } catch (error) {
      console.error('Error fetching special conditions:', error);
    }
  }, [data.application.dealer.id, application.id]);

  useEffect(() => {
    setIsContentHidden([APPLICATION_ROLES.ADMINISTRATOR].includes(role));
  }, [role]);

  useEffect(() => {
    if (selfAgreement) {
      setIsDisabled(true);

      return;
    }

    if (isPEP) {
      setIsDisabled(!isPEPSignature);

      return;
    }

    setIsDisabled(false);
  }, [selfAgreement, isPEP, isPEPSignature]);

  useEffect(() => {
    fetchSpecialConditions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    selfAgreement,
    isPEP,
    isDisabled,
    isSpecialСonditions,
    isPickUp,
    isShowDocuments,
    isContentHidden,
    setFocusAt,
  };
};
